import { render, staticRenderFns } from "./BeefPolicyModal.Style#Drawer.vue?vue&type=template&id=02f05f36&scoped=true"
import script from "./BeefPolicyModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./BeefPolicyModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./BeefPolicyModal.Style#Drawer.vue?vue&type=style&index=0&id=02f05f36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f05f36",
  null
  
)

export default component.exports